import React, { FC, ReactElement } from 'react'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import TraitFilterContent from './trait-filter-content'
import { Attribute } from '@/utils/types/collections'
import { BITMAP_NUMERICAL_ORDER_TRAIT } from '@/utils/bitmap-filters'

const TraitFilters: FC<{
	traits: Attribute[]
	onChange: (trait_type: string, filters: string[]) => void
	currentFilters: { values: string[], trait_type: string }[]
}> = (props): ReactElement => {
	const { traits, onChange, currentFilters } = props
	const forceOpen = traits && traits.length === 1 && traits[0].trait_type === 'Satributes'
	const openFirst = traits?.[0]?.trait_type === BITMAP_NUMERICAL_ORDER_TRAIT

	return (
		<Accordion type="multiple" defaultValue={forceOpen || openFirst ? ['0'] : undefined}>
			{traits?.map((trait, index) => (
				<AccordionItem key={index} value={index.toString()}>
					<AccordionTrigger>{trait.trait_type.charAt(0).toUpperCase() + trait.trait_type.slice(1)}</AccordionTrigger>
					<AccordionContent>
						<TraitFilterContent
							onChange={onChange}
							currentFilters={currentFilters}
							data={trait}
						/>
					</AccordionContent>
				</AccordionItem>
			))}
		</Accordion>
	)
}

export default TraitFilters
